import DynamicIcon, { IconName } from '@/components/DynamicIcon'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { badgeColorMap } from '@/utilities/badgeColorMap'
import { kebabToCamel } from '@/utilities/toCamel'
import { cn } from '@/utilities/ui'

import type { Topic } from '@/payload-types'

export const CategoryIcons = ({
  size = 'default',
  topics,
  className,
}: {
  size?: 'small' | 'default'
  topics: Topic[]
  className?: string
}) => {
  if (topics.length === 0) return null
  return (
    <div className={cn('relative flex items-center gap-2', className)}>
      {topics?.map((category, index) => {
        const topicColor = kebabToCamel(category.color || 'tuscany')
        return (
          <Tooltip delayDuration={0} key={`${category.id}-${index}`}>
            <TooltipTrigger asChild>
              <span
                className={cn(
                  'flex size-8 items-center justify-center rounded-xl transition-transform hover:scale-105',
                  badgeColorMap[topicColor].bg,
                  badgeColorMap[topicColor].text,
                  size === 'small' && 'rounded-t-none',
                )}
              >
                <DynamicIcon name={category.icon as IconName} className="size-4" />
              </span>
            </TooltipTrigger>
            <TooltipContent asChild>
              <div className="relative w-fit border-none bg-transparent shadow-none drop-shadow-md">
                <div
                  className={cn(
                    'flex items-center gap-2 rounded-full px-3.5 py-2 font-body text-reg font-medium',
                    badgeColorMap[topicColor].bg,
                    badgeColorMap[topicColor].text,
                    badgeColorMap[topicColor].border,
                  )}
                >
                  <DynamicIcon name={category.icon as IconName} className="size-5" />
                  {category.title}
                </div>
              </div>
            </TooltipContent>
          </Tooltip>
        )
      })}
    </div>
  )
}
